import React from 'react';
import { Link } from 'react-router-dom';
import AgeBandFilter, { AgeBandValue } from '../Filters/AgeBandFilter';
import RegimeFilter, { RegimeFilterValue } from '../Filters/RegimeFilter';
import '../../styles/CatalogHeader.css';

interface CatalogHeaderProps {
  chapter: string;
  title: string;
  subtitle: string;
  /** Counts shown beside the title — set to undefined while loading. */
  count?: number;
  ageBand: AgeBandValue;
  onAgeBandChange: (next: AgeBandValue) => void;
  regime: RegimeFilterValue;
  onRegimeChange: (next: RegimeFilterValue) => void;
}

const CatalogHeader: React.FC<CatalogHeaderProps> = ({
  chapter,
  title,
  subtitle,
  count,
  ageBand,
  onAgeBandChange,
  regime,
  onRegimeChange,
}) => (
  <header className="catalog-header">
    <div className="catalog-header__crumb">
      <Link to="/adotar">← voltar à escolha</Link>
    </div>

    <div className="catalog-header__row">
      <div>
        <div className="catalog-header__chapter">{chapter}</div>
        <h1 className="catalog-header__title">{title}</h1>
        <p className="catalog-header__subtitle">{subtitle}</p>
      </div>

      <div className="catalog-header__count" aria-live="polite">
        {count != null && (
          <>
            <span className="catalog-header__count-num">{count}</span>
            <span className="catalog-header__count-label">
              {count === 1 ? 'à espera' : 'à espera'}
            </span>
          </>
        )}
      </div>
    </div>

    <div className="catalog-header__filters">
      <AgeBandFilter value={ageBand} onChange={onAgeBandChange} />
      <RegimeFilter value={regime} onChange={onRegimeChange} />
    </div>
  </header>
);

export default CatalogHeader;
